import React from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import { addCustomerAddress, getCountryStates } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../../decl'

const AddNewAddress = (props) => {
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { customer_id, addressType, handleClose, countries } = props
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const [states, setStates] = React.useState([])
  const [data, setData] = React.useState({
    first_name: '',
    last_name: '',
    address1: '',
    address2: '',
    phone: '',
    city: '',
    state: '',
    zip: '',
    is_default: false,
    alternate_phone: '',
    fax: '',
    country: countries?.default,
  })

  React.useEffect(() => {
    getCountryStates(data.country).subscribe((res: any) => {
      setStates(res.response.data)
    })
  }, [data.country])
  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    addCustomerAddress({
      ...data,
      address_type: addressType,
      customer_id: customer_id,
    }).subscribe((res: any) => {
      hidePageLoader()
      if (res.response?.address_id) {
        showSuccess('Successfully Added')
        handleClose(res.response)
      } else {
        if (res.response.error && res.response.field) {
          setError(res.response)
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              First Name
            </DcText>
            <DcInput
              error={
                error.field === 'first_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'first_name'}
              placeholder={'First Name'}
              value={data.first_name}
              onChange={(e) => setData({ ...data, first_name: e.target.value })}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Last Name
            </DcText>
            <DcInput
              error={
                error.field === 'last_name' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'last_name'}
              placeholder={'Last Name'}
              value={data.last_name}
              onChange={(e) => setData({ ...data, last_name: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Address Line 1
            </DcText>
            <DcInput
              error={
                error.field === 'address1' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'address1'}
              placeholder={'Address Line 1'}
              value={data.address1}
              onChange={(e) => setData({ ...data, address1: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Address Line 2
            </DcText>
            <DcInput
              error={
                error.field === 'address2' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'address2'}
              placeholder={'Address Line 2'}
              value={data.address2}
              onChange={(e) => setData({ ...data, address2: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Phone
            </DcText>
            <DcInput
              error={
                error.field === 'phone' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'phone'}
              placeholder={'Phone'}
              value={data.phone}
              onChange={(e) => setData({ ...data, phone: e.target.value })}
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Alternate Phone
            </DcText>
            <DcInput
              error={
                error.field === 'alternate_phone' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'alternate_phone'}
              placeholder={'Alternate Phone'}
              value={data.alternate_phone}
              onChange={(e) =>
                setData({ ...data, alternate_phone: e.target.value })
              }
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Fax
            </DcText>
            <DcInput
              error={
                error.field === 'fax' && error.error !== '' ? error.error : null
              }
              type={'text'}
              name={'fax'}
              placeholder={'Fax'}
              value={data.fax}
              onChange={(e) => setData({ ...data, fax: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              City
            </DcText>
            <DcInput
              error={
                error.field === 'city' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'city'}
              placeholder={'City'}
              value={data.city}
              onChange={(e) => setData({ ...data, city: e.target.value })}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              State
            </DcText>
            <DcDropDown
              error={
                error.field === 'state' && error.error !== ''
                  ? error.error
                  : null
              }
              placeholder={'Select State'}
              options={[
                {
                  name: 'Select State',
                  code: '',
                },
                ...states,
              ].map((p) => {
                return {
                  label: p.name,
                  value: p.code,
                }
              })}
              value={data.state}
              onChange={(e) => {
                setData({ ...data, state: e.target.value })
              }}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Country
            </DcText>
            <DcDropDown
              error={
                error.field === 'country' && error.error !== ''
                  ? error.error
                  : null
              }
              placeholder={'Select Country'}
              options={countries?.list?.map((p) => {
                return {
                  label: p.name,
                  value: p.two_letter_abbreviation,
                }
              })}
              value={data.country}
              onChange={(e) => {
                setData({ ...data, country: e.target.value })
              }}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Zip Code
            </DcText>
            <DcInput
              error={
                error.field === 'zip' && error.error !== '' ? error.error : null
              }
              required
              parentStyle={{
                width: '50%',
              }}
              type={'text'}
              name={'zip'}
              placeholder={'Zip Code'}
              value={data.zip}
              onChange={(e) => setData({ ...data, zip: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox padding="10px 0 0 0" height="auto" justifyContent="flex-end">
          <DcButton
            style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
            variant="primary"
            type="submit"
            size="sm"
          >
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </DcFlexBox>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
`

export default AddNewAddress
